import {Component, Input, OnInit} from '@angular/core';
import {SubscribedComponent} from "../subscribed.component";
import {FileEntry} from "../interfaces/fileEntry";
import {Globals} from "../shared/Globals";

@Component({
    selector: 'bst-photo-well',
    templateUrl: './photo-well.component.html',
    styleUrls: ['./photo-well.component.scss'],
    standalone: false
})
export class PhotoWellComponent extends SubscribedComponent{

  @Input() public default: string;
  @Input() public file: FileEntry;
  @Input() public shape:'round'|'semi-round'|'rectangle' = 'round';
  @Input() public color: string = '#f7f9fc';
  // Optional name to derive an initials fallback when there is no image, so an
  // empty avatar reads as a placeholder, not an unfinished blank ring.
  @Input() public name: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  get alt(): string{
    return '';
  }

  get src(): string{
    if(this.file && this.file.preview){
      return Globals.storage(this.file.preview);
    }
    else if(this.default){
      return this.default;
    }
    return null;
  }

  get initials(): string{
    if(!this.name) return null;
    const parts = this.name.trim().split(/\s+/).filter(Boolean);
    if(!parts.length) return null;
    const first = parts[0][0] ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1][0] ?? '') : '';
    return (first + last).toUpperCase() || null;
  }

}
